// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1zAsb","rootSmall":"AddTileButton_rootSmall__3JuxM"};